import TableCell from '@material-ui/core/TableCell';
import { useState, useEffect } from 'react';

function BooleanTableCell(props) {
	const [label, setLabel] = useState(null);

	useEffect(() => {
		if (props.item[props.config.key] != null) {
			setLabel(props.item[props.config.key] ? 'Igen' : 'Nem');
		} else {
			setLabel('');
		}
	}, [props.item, props.config]);

	return (
		<TableCell className="p-4 md:p-16" scope="row">
			{label}
		</TableCell>
	);
}

export default BooleanTableCell;
